import { all, fork, put, takeLatest, call, select, delay } from "redux-saga/effects"
import { getItems } from "util/localStorage"

import * as actionTypes from "appRedux/actions/setup/systemSetup/systemConfigActionType"
import * as actionCreators from "appRedux/actions/setup/systemSetup/systemConfig"
import { userSignOut } from "appRedux/actions/Auth"

import { APIGetRequest, APIPostRequest } from "util/connection"
import { API_URL_V1, API_PMS_HEADERS } from "constants/ApiSetting"
import { ApiResponse } from "constants/ActionTypes"
import { AppState } from "ReducerState"

function* systemConfigPreviewProcess() {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/system/config/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

    try {
        const response: ApiResponse = yield APIGetRequest(url, API_PMS_HEADERS)

        if (response.status === 200) {
            const { data: { system_params } } = response
            /* @system params : 
                { SYSTEM, DEFAULT, TAX, ROOM_RATE, CALENDAR, BACKUP, CASHIER,DEPOSIT,
                ENDDAY, FOLIO, GUEST_PROFILE, RESERVATION, ROOM_STATUS }  */
            yield put(actionCreators.systemConfigDataSourceUpdate(system_params))
            yield delay(100)
        } else {
            /* Show error message and signout */
            const { message, data } = response.data
            const processStatus = { status: false, action: "systemConfigPreview", message }
            yield put(actionCreators.systemConfigProcessSuccess(processStatus))
            yield delay(100)
            if (response.status === 403) {
                /* if data is not null force signout */
                if (data)
                    yield put(userSignOut())
            }
        }
    } catch (error) {
    }
}

function* systemConfigUpdateProcess({ payload }: actionTypes.SystemConfigUpdate) {

    const { systemPrepareUpdate: dynamicValue } = yield select((state: AppState) => state?.systemConfig)
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/system/config/update`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    try {
        const API_DATABODY = { system_params: { ...dynamicValue } }
        const response: ApiResponse = yield APIPostRequest(url, API_DATABODY, API_PMS_HEADERS)
        if (response.status === 200) {
            const processStatus = { status: true, action: "update", message: "Update Success" }
            yield put(actionCreators.systemConfigProcessSuccess(processStatus))
            yield delay(100)
            yield delay(1000)
            yield put(actionCreators.systemConfigPrepareUpdateReset())
            yield delay(100)
            yield put(actionCreators.systemConfigPreview())
            yield delay(100)
        } else {
            /* Show error message and signout */
            const { message, data } = response.data
            const processStatus = { status: false, action: "update", message }
            yield put(actionCreators.systemConfigProcessSuccess(processStatus))
            yield delay(100)
            if (response.status === 403) {
                /* if data is not null force signout */
                if (data)
                    yield put(userSignOut())
            }
        }
    } catch (error) {
    }
}

function* systemConfigSystemDateSetupProcess({ payload }: actionTypes.SystemConfigSystemDateSet) {
    /* "SYSTEM_DATE": "2025-06-12" */
    const { dataSource} = yield select((state:AppState) => state.systemConfig)
    const newDataSource = {
        ...dataSource,
        SYSTEM: {
            ...dataSource.SYSTEM,
            SYSTEM_DATE: payload.SYSTEM_DATE
        }
    }

    try {
        yield put(actionCreators.systemConfigDataSourceUpdate(newDataSource))
        yield delay(100)
    } catch (error) {
    }

}

/* Watcher Saga */
export function* systemConfigPreview() {
    yield takeLatest(actionTypes.SYSTEM_CONFIG_PREVIEW, systemConfigPreviewProcess)
}
export function* systemConfigUpdate() {
    yield takeLatest(actionTypes.SYSTEM_CONFIG_UPDATE, systemConfigUpdateProcess)
}

export function* systemConfigSystemDateSetup() {
    yield takeLatest(actionTypes.SYSTEM_CONFIG_SYSTEM_DATE_SET, systemConfigSystemDateSetupProcess)
}

export default function* rootSaga() {
    yield all([fork(systemConfigPreview),
    fork(systemConfigUpdate),
    fork(systemConfigSystemDateSetup)
    ])
}
